"use strict";

exports.__esModule = true;
exports.WidgetPalette = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _WidgetPaletteItem = require("./WidgetPaletteItem");
var _widgetGroups = require("../../Widgets/widgetGroups");
var _WidgetGroup = require("./WidgetGroup");
var _excluded = ["widgets", "elementEditor"];
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _inheritsLoose(t, o) { t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf(t, o); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var WidgetPaletteContainer = _styledComponents["default"].div.withConfig({
  displayName: "WidgetPalette__WidgetPaletteContainer",
  componentId: "sc-8c6vz5-0"
})(["width:100%;padding-bottom:128px;display:flex;flex-direction:column;"]);

/**
 * Displays a list of widgets that can be dragged onto a drawing surface.
 */
var WidgetPalette = exports.WidgetPalette = /*#__PURE__*/function (_Component) {
  function WidgetPalette() {
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, [this].concat(args)) || this;
    _this.state = {
      components: collectThumbnailComponents(_this.props.widgets)
    };
    _this.handleBeginDrag = function () {
      var elementEditor = _this.props.elementEditor;
      elementEditor.beginDrag(undefined);
    };
    _this.handleEndDrag = function () {
      var elementEditor = _this.props.elementEditor;
      elementEditor.endDrag(undefined);
    };
    return _this;
  }
  _inheritsLoose(WidgetPalette, _Component);
  var _proto = WidgetPalette.prototype;
  _proto.render = function render() {
    var _widgets$reduce,
      _this2 = this;
    var _this$props = this.props,
      widgets = _this$props.widgets,
      _elementEditor = _this$props.elementEditor,
      extra = _objectWithoutPropertiesLoose(_this$props, _excluded);
    var components = this.state.components;
    var groupedWidgets = widgets.reduce(function (widgetDictionary, widget) {
      if (!widget.group) widget.group = _widgetGroups.OTHER_WIDGET;
      if (widgetDictionary[widget.group]) {
        widgetDictionary[widget.group].push(widget);
      } else {
        widgetDictionary[widget.group] = [widget];
      }
      return widgetDictionary;
    }, (_widgets$reduce = {}, _widgets$reduce[_widgetGroups.LAYOUT_WIDGET] = [], _widgets$reduce[_widgetGroups.DEVICE_INFORMATION_WIDGET] = [], _widgets$reduce[_widgetGroups.TIMELINE_WIDGET] = [], _widgets$reduce[_widgetGroups.METRIC_WIDGET] = [], _widgets$reduce[_widgetGroups.ACTION_WIDGET] = [], _widgets$reduce[_widgetGroups.RAW_DATA_WIDGET] = [], _widgets$reduce[_widgetGroups.DIGITAL_LOG_WIDGET] = [], _widgets$reduce[_widgetGroups.KNOWLEDGE_BASE_WIDGET] = [], _widgets$reduce[_widgetGroups.OTHER_WIDGET] = [], _widgets$reduce));
    return /*#__PURE__*/_react["default"].createElement(WidgetPaletteContainer, _extends({
      "data-testid": "WidgetPalette"
    }, extra), Object.entries(groupedWidgets).map(function (_ref) {
      var key = _ref[0],
        widgetGroup = _ref[1];
      if (widgetGroup.length === 0) return;
      return /*#__PURE__*/_react["default"].createElement(_WidgetGroup.WidgetGroup, {
        widgetGroupKey: key,
        key: key
      }, widgetGroup.map(function (widget) {
        return /*#__PURE__*/_react["default"].createElement(_WidgetPaletteItem.WidgetPaletteItem, {
          key: widget.name,
          widget: widget,
          onBeginDrag: _this2.handleBeginDrag,
          onEndDrag: _this2.handleEndDrag,
          components: components
        });
      }));
    }));
  };
  return WidgetPalette;
}(_react.Component);
function collectThumbnailComponents(widgets) {
  var components = {};
  for (var i = 0; i < widgets.length; i++) {
    var widget = widgets[i];
    if (widget.components.Thumbnail) {
      components[widget.name] = widget.components.Thumbnail;
    }
  }
  return components;
}